import * as actionTypes from '../constants/actionTypes';

export function showChannelFrame() {
    return {type: actionTypes.SHOW_CHANNEL_FRAME};
}

export function showPlayerFrame() {
    return {type: actionTypes.SHOW_PLAYER_FRAME};
}

export function showUserDataFrame() {
    return {type: actionTypes.SHOW_USERDATA_FRAME};
}


// WEBPACK FOOTER //
// ./src/actions/appContent.js